export default "__VITE_ASSET__B$HN2jtc__";